import Route from 'cio/routes/base';

export default class ReviewRoute extends Route {
  crumb() {
    let { import: model } = this.modelFor('segments.segment.imports.csv.setup');

    return {
      name: 'Review',
      path: 'segments.segment.imports.csv.setup.review',
      model,
    };
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.setDefaults();
    }
  }
}
